import { store } from "../app/store";

export const SOCKET_AUTH_STORAGE_KEYS = [
  "ats_local_auth_token",
  "user_access_cookies",
  "access_token",
  "accessToken",
  "token",
];

/** Persist token for socket handshake when session is cookie-only (SSO / marketplace). */
export function persistSocketAccessToken(token) {
  if (typeof window === "undefined") return;
  const trimmed = typeof token === "string" ? token.trim() : "";
  if (trimmed) {
    window.localStorage.setItem("access_token", trimmed);
  } else {
    window.localStorage.removeItem("access_token");
  }
}

export function getSocketAccessToken() {
  if (typeof window === "undefined") return "";

  const cookieMap = document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .filter(Boolean)
    .reduce((acc, cookie) => {
      const separatorIndex = cookie.indexOf("=");
      if (separatorIndex < 0) return acc;
      const key = decodeURIComponent(cookie.slice(0, separatorIndex));
      const value = decodeURIComponent(cookie.slice(separatorIndex + 1));
      acc[key] = value;
      return acc;
    }, {});

  if (cookieMap.user_access_cookies) {
    return cookieMap.user_access_cookies;
  }

  for (const key of SOCKET_AUTH_STORAGE_KEYS) {
    const value = window.localStorage.getItem(key);
    if (value && value.trim()) {
      return value.trim();
    }
  }

  return "";
}

let prevIsUserLogin;
let prevAccessToken;

/**
 * Connect or reconnect the socket when login or auth token changes.
 * Safe to call after SSO, getUserInfo, or email login.
 */
export function syncSocketConnection(socket) {
  if (!socket) return;

  const isUserLogin = store.getState()?.persist?.isUserLogin;
  const apiAccessToken = getSocketAccessToken();

  if (!isUserLogin) {
    if (prevIsUserLogin) {
      socket.disconnect();
    }
    prevIsUserLogin = isUserLogin;
    prevAccessToken = apiAccessToken;
    return;
  }

  const loginChanged =
    prevIsUserLogin !== undefined && prevIsUserLogin !== isUserLogin;
  const tokenChanged =
    prevAccessToken !== undefined && prevAccessToken !== apiAccessToken;
  const shouldReconnect =
    loginChanged || tokenChanged || !socket.connected;

  prevIsUserLogin = isUserLogin;
  prevAccessToken = apiAccessToken;

  if (!shouldReconnect) return;

  socket.io.opts.query = apiAccessToken
    ? { "api-access-token": apiAccessToken }
    : {};
  socket.auth = apiAccessToken ? { token: apiAccessToken } : {};

  if (socket.connected) {
    socket.disconnect();
  }
  socket.connect();
}
